import { defineStore } from 'pinia'
import { sendParams, reciptParams, goodsInfo } from '@/utils'

export const addrStoreInfo = defineStore('addrStoreInfo', {
  state: () => ({
    image: '',
    imageUrl: '',
    width: 0,
    isTrue: false,
    /**是否新用户 */
    isNewUser: 'NO',
    /**是否0元寄 */
    isZeroCost: false,
    /**寄件人 */
    sender: {
      ...sendParams()
    } as any,
    /**收件人 */
    recipt: {
      ...reciptParams()
    } as any,
    /**其他物品信息 */
    goodsInfo: {
      ...goodsInfo()
    }
  }),
  getters: {
    getIsTrue: (state) => state.isTrue,
    getImage: (state) => state.image,
    getImageUrl: (state) => state.imageUrl,
    getGoodsInfo: (state) => state.goodsInfo,
    getSenderInfo: (state) => state.sender,
    getReciptInfo: (state) => state.recipt,
    getClientWidth: (state) => state.width,
    getIsNewUser: (state) => state.isNewUser,
    getIsZeroCost: (state) => state.isZeroCost
  },
  actions: {
    setIsNewUser(data: string) {
      this.isNewUser = data
    },
    setIsZeroCost(data: boolean) {
      this.isZeroCost = data
    },
    setClientWidth(data: number) {
      this.width = data
    },
    setImage(data: string) {
      this.image = data
    },
    setImageUrl(data: string) {
      this.imageUrl = data
    },
    setIsOrder(data: boolean) {
      this.isTrue = data
    },
    insertSenderInfo(data: Object) {
      Object.assign(this.sender, data)
    },
    insertReciptInfo(data: Object) {
      Object.assign(this.recipt, data)
    },
    setGoodsInfo(data: any) {
      if (data.fastParcelType === 'SP') {
        data.bagType = 'NONE'
      }
      Object.assign(this.goodsInfo, data)
    }
  },
  persist: {
    storage: localStorage
  }
})
